import React from 'react';
import './Header.css';

function Header() {
  return (
    <h1>star wars</h1>
  );
}
export default Header;
